import { ArrowLeftStartOnRectangleIcon } from '@heroicons/react/24/outline'
import { deleteCookie } from 'cookies-next/client'
import { redirect } from 'next/navigation'
import { twMerge } from 'tailwind-merge'
import { pages } from '@/settings'
import { useGlobalStore } from '@/store/provider'

type Props = {
  className?: string
}

export default function Signout({ className }: Props) {
  const { user, setUser } = useGlobalStore((state) => state)
  const signOut = () => {
    setUser(null, null)
    // delete cookies
    deleteCookie('admin_access_token')
    deleteCookie('admin_refresh_token')
    deleteCookie('admin_id_token')
    redirect(pages.signIn.href)
  }
  return (
    <button
      type='button'
      onClick={() => signOut()}
      className={twMerge(
        'flex h-8 items-center justify-center rounded pl-2 pr-3 transition border-zinc-300 hover:bg-zinc-200 dark:hover:bg-zinc-700',
        className,
      )}
    >
      <ArrowLeftStartOnRectangleIcon className='w-4' />
      <span className='pl-1.5 text-sm' title={user?.email}>
        Sign out
      </span>
    </button>
  )
}
